<template>
    <svg xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        :viewBox="viewBox"
        :aria-labelledby="iconName"
        role="presentation"
        :class="{active: interactive == true}"
        v-on:click="onClick" >
        <title
            :id="iconName"
            lang="en">
            {{ iconName }}
        </title>
        <g :fill="iconColor">
            <slot />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconBase',
    props: {
        interactive: {
            type: Boolean,
            default: true
        },
        iconName: {
            type: String,
            default: 'icon'
        },
        width: {
            type: [Number, String],
            default: 24
        },
        height: {
            type: [Number, String],
            default: 24
        },
        viewBox: {
            type: String,
            default: '0 0 47 47'
        },
        iconColor: {
            type: String,
            default: 'black'
        }
    },
    methods: {
        onClick() {
            if(this.interactive) {
                this.$emit('onIconClicked');
            }
        }
    }
}
</script>

<style scoped>
    .active {
        background-color: white;
    }

    .active:hover {
        background-color: black;
        cursor: pointer;
    }

    .active:hover g {
        fill: white;
    }
</style>